/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2018
 *
 * Created by maximeallex on 2018-04-11.
 */
'use strict';

import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[context-element]',
})
export class ContextElementDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
